import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-print-allotmentletter',
  templateUrl: './print-allotmentletter.component.html',
  styleUrls: ['./print-allotmentletter.component.css']
})
export class PrintAllotmentletterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/allocation/print-allotmentletter/print-allotmentletter.component.ts